export enum FormMode {
  CreateMode,
  EditMode,
  ViewMode,
  SelfEdit,
  Search
}
